<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Respostas</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Consulte, filtre e acompanhe as respostas recebidas nas campanhas.</p>
        </div>
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
            <div class="flex flex-col gap-1">
              <label class="text-sm font-medium text-gray-500">A partir de</label>
              <input
                v-model="form.de"
                type="datetime-local"
                class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
              />
            </div>

            <div class="flex flex-col gap-1">
              <label class="text-sm font-medium text-gray-500">Até</label>
              <input
                v-model="form.ate"
                type="datetime-local"
                class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
              />
            </div>

            <div class="flex flex-col gap-1">
              <label class="text-sm font-medium text-gray-500">Centro de custo</label>

              <div class="relative group">
                <select
                  v-model="centrocusto"
                  id="centrocusto-select"
                  class="h-11 w-full cursor-pointer appearance-none rounded-xl border border-gray-200 bg-white bg-none px-4 pr-10 text-gray-700 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                >
                  <option :value="null">Todos</option>
                  <option v-for="c in centroscusto" :key="c._id" :value="c._id">
                    {{ c.nome }}
                  </option>
                </select>

                <svg class="select-icon h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            <div class="flex items-end gap-2 md:col-span-4 lg:col-span-1">
              <button type="button" class="h-11 w-full rounded-xl bg-blue-500 font-medium text-white transition hover:bg-blue-600" @click="list">Buscar</button>

              <a :href="downloadUrl" class="flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 transition hover:bg-gray-50">
                <svg class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16" />
                </svg>
                Download
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="text-sm text-gray-500">{{ total }} registro(s)</div>

      <div class="w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Data</th>
                <th class="px-6 py-4 text-left font-medium">Telefone</th>
                <th class="px-6 py-4 text-left font-medium">Resposta</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="el in respostas" :key="el._id" class="border-b border-gray-100 transition hover:bg-slate-50">
                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ moment(el.data).format("DD/MM/YYYY") }}
                </td>

                <td class="px-6 py-5 text-gray-700">
                  {{ el.telefone || "-" }}
                </td>

                <td class="px-6 py-5 text-gray-700">
                  <div v-if="!el.type || el.type === 'chat'" class="leading-relaxed" v-html="getHtmlFrom(el.mensagem)" />

                  <img v-if="el.type === 'image_file'" :src="el.base64" class="max-h-40 rounded-xl border border-gray-200 shadow-sm" />

                  <a v-if="el.type === 'document_file'" :href="el.base64" target="_blank" class="font-medium text-blue-700 transition hover:text-blue-800"> Abrir documento </a>
                </td>
              </tr>

              <tr v-if="respostas.length === 0">
                <td colspan="3" class="px-6 py-12 text-center text-sm text-gray-400">Nenhum resultado encontrado com os filtros atuais.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <AppPagination
        :current-page="page"
        :page-size="perPage"
        :total-items="total"
        :total-pages="totalPages"
        item-label="respostas"
        @paginate="setPage"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import AppPagination from "@/components/AppPagination.vue";
import vCard from "vcard-parser";
import { escaparHtml } from "@/utils/formatarMensagem";

export default {
  components: {
    AppPagination
  },

  data() {
    return {
      route: "respostas",
      apilz: window.location.hostname === "uno.trestto.com.br" ? "https://uno.trestto.com.br/api" : process.env.VUE_APP_API,

      moment,
      vCard,

      respostas: [],
      centroscusto: [],
      centrocusto: null,

      page: 1,
      perPage: 25,
      total: 0,

      form: {
        busca: "",
        de: moment().startOf("day").format("YYYY-MM-DDTHH:mm"),
        ate: moment().endOf("day").format("YYYY-MM-DDTHH:mm")
      }
    };
  },

  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.perPage));
    },

    downloadUrl() {
      const centrocusto = this.centrocusto || "";

      return `${this.apilz}/v1/campanhasLZV2/respostas/download?token=${this.$store.state.token}&de=${this.form.de}&ate=${this.form.ate}&centrocusto=${centrocusto}`;
    }
  },

  methods: {
    getHtmlFrom(str) {
      if (!str) return str;

      return escaparHtml(str).replace(/\*(.*?)\*/g, "<b>$1</b>").replace(/\n/g, "<br/>");
    },

    getVcard(str) {
      const parsed = vCard.parse(str);

      return `${parsed?.n?.[0]?.value?.[1] || ""}`;
    },

    async setPage(page) {
      this.page = page;

      const response = await this.$http.post("/v1/campanhasLZV2/respostas/list", {
        ...this.form,
        centrocusto: this.centrocusto,
        limit: this.perPage,
        skip: (page - 1) * this.perPage
      });

      this.respostas = response?.data?.data || [];
      this.total = response?.data?.total || 0;
    },

    async list() {
      await this.setPage(1);
    },

    async carregarCentrosCusto() {
      const response = await this.$http.post("/v1/centrocusto/list", { all: true });
      this.centroscusto = response?.data?.data || [];

      if (this.$store.state.user.centrocusto) {
        this.centrocusto = this.$store.state.user.centrocusto;
      }
    }
  },

  async beforeMount() {
    await this.carregarCentrosCusto();
    await this.list();
  }
};
</script>

<style scoped>
.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

#centrocusto-select::-ms-expand {
  display: none;
}

#centrocusto-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}
</style>
